import {store} from "react-notifications-component";
import {TOAST_TYPES, LOCAL_STORAGE_KEYS} from "./constants";
import {REGIONS_MAP} from "./META/cat_101";
import {countries} from "./countries";

export const toast = (type, title, message, duration = 10000) => {
    store.addNotification({
        title,
        message,
        type,
        insert: "bottom",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
            duration,
            showIcon: true
        }
    });
}

export const toastWarning = (message) => {
    toast(TOAST_TYPES.WARN, "Server Response!", message);
}

export const getMapFromObjectListByKey = (objectList, mapKey) => {
    let dict = {};
    for (let item of objectList) {
        dict[item[mapKey]] = item;
    }
    return dict;
}

export const getArrayFromMap = (map) => {
    return Object.keys(map).map((k) => map[k])

}

export const getPresenceMap = (simple_list) => {
    let dict = {};
    for (let item of simple_list) {
        dict[item] = true;
    }
    return dict;
}

export const asciiSortCompareFunWithKey = (key) => {
    return (a, b) => a[key].localeCompare(b[key]);
}

export function* chunks(arr, n) {
    for (let i = 0; i < arr.length; i += n) {
        yield arr.slice(i, i + n);
    }
}

export function* varChunks(arr, n) { //variable length chunks
    const n_array = [].concat(n);

    function getNextSize(array, i) {
        return array[i] ? array[i] : array[array.length - 1];
    }

    for (let i = 0, j = 0; i < arr.length; i += getNextSize(n_array, j), j += 1)
    {
        yield arr.slice(i, i + getNextSize(n_array, j));
    }
}

export const splitEveryNthPos = function (string, separator, position) {
    const split_array = string.split(separator)
    const split_array_len = split_array.length;
    const final_array = [];
    let buffer = "";
    for(let word_index in split_array){
        const word = split_array[word_index]
        buffer += (word);
        if(buffer.length >= position || parseInt(word_index) === split_array_len-1){ //if buffer has max length possible, or we have reached last index
            final_array.push(buffer)
            buffer = ""
        }
        else {
            buffer += separator
        }
    }
    return final_array;
}

String.prototype.format = function(placeholders) {
    let s = this;
    for(const propertyName in placeholders) {
        const re = new RegExp('{' + propertyName + '}', 'gm');
        s = s.replace(re, placeholders[propertyName]);
    }
    return s;
};


export function removeSaltAtPos(saltedBase64String, interval = 5) {
    let cleanedString = '';
    let charsBeforeSalt = interval - 1; // Match the adjustment in addSalt

    for (let i = 0, count = 0, n = saltedBase64String.length; i < n; i++) {
        count++;

        // Add every character to the cleaned string except those at the salt positions
        if (count !== interval) {
            cleanedString += saltedBase64String[i];
        } else {
            count = 0; // Reset count after skipping a salt character
        }
    }

    return cleanedString;
}

export function save_e2ee_keys(result) {
    const e2ee_keypair_object = {pub: result.data.e2ee_pub_key, pvt: result.data.e2ee_pvt_key};
    const e2ee_obj_str = JSON.stringify(e2ee_keypair_object);
    localStorage.setItem(LOCAL_STORAGE_KEYS.e2ee_krypto_pair_obj, btoa(e2ee_obj_str));
}

export function use_e2ee() {
    return process.env.REACT_APP_E2EE_ENABLE === '1' && localStorage.getItem(LOCAL_STORAGE_KEYS.qa_mode) !== '1';
}

export const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const formatDuration = (minutes, locale) => {
    const { tUi } = require('./dq_lc');
    const minutesLabel = locale ? tUi('duration.minutes', locale) : 'minutes';
    const hourLabel = locale ? tUi('duration.hour', locale) : 'hour';
    const hoursLabel = locale ? tUi('duration.hours', locale) : 'hours';
    const andLabel = locale ? tUi('duration.and', locale) : 'and';

    if (minutes < 60) {
        return `${minutes} ${minutesLabel}`;
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const hourText = hours === 1 ? hourLabel : hoursLabel;

    if (remainingMinutes === 0) {
        return `${hours} ${hourText}`;
    }
    return `${hours} ${hourText} ${andLabel} ${remainingMinutes} ${minutesLabel}`;
};

/**
 * Convert country value to ISO 3166-1 alpha-2 country code for Stripe/international APIs
 * @param {string} input - Country value from profile.country (can be REGIONS value, label, or ISO code)
 * @returns {string} - The ISO country code (e.g., "US") or original input if not found
 *
 * @example
 * getCountryCode('USA') // → 'US'
 * getCountryCode('United States') // → 'US'
 * getCountryCode('US') // → 'US'
 */
export const getCountryCode = (input) => {
    if (!input) return '';

    const trimmed = input.trim();

    // If already a 2-letter ISO code, return it
    if (/^[A-Z]{2}$/i.test(trimmed)) {
        return trimmed.toUpperCase();
    }

    // Get label from REGIONS_MAP (cat_101.js) if it's a REGIONS value
    const countryLabel = REGIONS_MAP[trimmed]?.name || trimmed;

    // Find ISO code from countries.js by matching the label
    const country = countries.find(c =>
        c.label.toLowerCase() === countryLabel.toLowerCase()
    );

    // Return the code if found, otherwise return original input
    return country ? country.code : input;
};
